import { COMPARISON_QUERY_PARAM_NAMES } from '~/constants/assetComparison';
import { QueryParamNames } from '~/constants/search';

// The next asset open copies the current query, so these must not remain on the parent page.
export const ASSET_MODAL_PARAMS_TO_OMIT: QueryParamNames[] = [
  ...COMPARISON_QUERY_PARAM_NAMES,
  QueryParamNames.timestamp,
  QueryParamNames.amTab,
  QueryParamNames.discussionId,
  QueryParamNames.versions,
  QueryParamNames.capturedTextId,
  QueryParamNames.faceId,
  QueryParamNames.clipPersonId,
  QueryParamNames.page,
  QueryParamNames.expandedSections,
];
